// extracted by mini-css-extract-plugin
export default {"label":"PropertyLocation_label__OsQjt","group":"PropertyLocation_group__geZjg"};